import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  CircularProgress,
  TextField,
  useTheme,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PayPalIcon from "@mui/icons-material/AccountBalanceWallet";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { API_GET_USERID, API_POST } from "../../API/config";
import { API_endpoints } from "../../API/API_Endpoints";
import { toast } from "react-toastify";
import { cleanFilterItem } from "@mui/x-data-grid/hooks/features/filter/gridFilterUtils";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#fff",
  boxShadow: 12,
  p: 4,
  borderRadius: "12px",
  outline: "none",
};

export default function CheckoutModal({
  setOpen,
  open,
  data,
  handlePaypalSubmit,
  handleCardSubmit,
  loading,
}) {
  const handleClose = () => {
    // Clear all details when closing the modal
    setCouponCode("");
    setCouponDiscountData({});
    setResult(null);
    setCurrentLoading(null);
    setOpen(false);
  };

  let fiesta = localStorage.getItem("Fiesta");
  fiesta = fiesta ? JSON.parse(fiesta) : {};
  const [currentLoading, setCurrentLoading] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const [couponCode, setCouponCode] = useState("");
  const [couponVerifyLoading, setCouponVerifyLoading] = useState(false);
  const [couponDiscountData, setCouponDiscountData] = useState({});
  const [result, setResult] = useState(null);
  const [finalAmountRef, setfinalAmountRef] = useState(0);

  const getCompanyId = async (id) => {
    try {
      let res = await API_GET_USERID(API_endpoints.usergetbyid, id);
      if (res?.s) {
        const d = res?.r?.company_details?.company_name;
        d && setCompanyName(d);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleVerifyCoupon = async (code, Sub_id) => {
    try {
      setCouponVerifyLoading(true);
      const formData = new FormData();
      formData.append("coupon_code", code);
      formData.append("subscription_id", Sub_id);
      let res = await API_POST(API_endpoints.VerifyDiscountCoupon, formData);
      if (res?.s) {
        const r = applyCoupon(data?.price, res?.r);
        setResult(r);
        setCouponDiscountData(res?.r);
        if (res?.m === "Success") {
          toast.success(
            i18n.language === "en-US" || i18n.language === "en"
              ? t("checkout.msg.success")
              : t("checkout.msg.success")
          );
        }
      } else {
        let msg;
        if (res?.m === "Coupon code is invalid or expired") {
          msg =
            i18n.language === "en-US" || i18n.language === "en"
              ? res?.m
              : t("checkout.msg.invalid");
        } else if (res?.m === "You have already used this coupon code") {
          msg =
            i18n.language === "en-US" || i18n.language === "en"
              ? res?.m
              : t("checkout.msg.used");
        } else if (
          res?.m === "The coupon code has reached its maximum usage limit"
        ) {
          msg =
            i18n.language === "en-US" || i18n.language === "en"
              ? res?.m
              : t("checkout.msg.limit");
        }
        toast.error(msg);
      }
      setCouponVerifyLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fiesta && getCompanyId(fiesta?.id);
  }, [fiesta]);

  function applyCoupon(originalAmount, coupon) {
    if (!coupon || coupon.status !== 1)
      return { finalAmount: originalAmount, discount: 0 };

    let discount = 0;

    if (coupon.discount_type === 1) {
      // Percentage discount
      discount = (originalAmount * coupon.discount_amount) / 100;
    } else if (coupon.discount_type === 2) {
      // Fixed amount discount
      discount = coupon.discount_amount;
    }

    const finalAmount = Math.max(0, originalAmount - discount);
    const savedAmount = Math.max(0, originalAmount - finalAmount);
    setfinalAmountRef(finalAmount);

    return {
      finalAmount,
      discount,
      savedAmount,
      couponCode: coupon.coupon_code,
      couponName: coupon.coupon_name,
    };
  }

  const isFreeViaCoupon = couponDiscountData && result && finalAmountRef === 0;

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: { xs: "95%", sm: "400px" } }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h5" fontWeight="bold" color="text.primary">
              {t("checkout.checkout_summary")}
            </Typography>
            <IconButton
              onClick={handleClose}
              sx={{
                color: theme.palette.text.secondary,
                "&:hover": {
                  color: theme.palette.error.main,
                  backgroundColor: "rgba(211, 47, 47, 0.04)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Card
            sx={{
              width: "100%",
              boxShadow: 3,
              borderRadius: 2,
            }}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between" my={1}>
                <Typography color="text.secondary">
                  {t("checkout.company_name")}
                </Typography>
                <Typography fontWeight="bold">{companyName}</Typography>
              </Box>

              <Box display="flex" justifyContent="space-between" my={1}>
                <Typography color="text.secondary">
                  {t("checkout.membership_choice")}
                </Typography>
                <Typography color="#fd5d29" fontWeight="bold">
                  €{data?.price} /{" "}
                  {data?.subType === 0
                    ? t("checkout.months")
                    : t("checkout.years")}
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TextField
                  type="text"
                  id="couponCode"
                  name="couponCode"
                  onChange={(e) => setCouponCode(e.target.value)}
                  value={couponCode}
                  variant="outlined"
                  placeholder={t("checkout.enterCode")}
                  InputProps={{
                    sx: {
                      borderRadius: "12px",
                      height: "50px",
                      color: theme.palette.text.defaultDark,
                      "&:hover": {
                        color: theme.palette.text.active,
                        bgcolor: theme.palette.background.inputBg,
                        borderRadius: "12px",
                      },
                    },
                    endAdornment: couponCode && (
                      <IconButton
                        onClick={() => {
                          setCouponCode("");
                          setCouponDiscountData(null);
                          setResult(null);
                        }}
                        edge="end"
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#fd5d29",
                    color: "#FFF",
                    fontWeight: "bold",
                    "&:hover": { bgcolor: "#fd5d29" },
                    py: 1.5,
                    px: 3,
                    textTransform: "none",
                    borderRadius: "12px",
                  }}
                  // disabled={loading || (couponDiscountData && result)}
                  onClick={() => {
                    handleVerifyCoupon(couponCode, data?.id);
                  }}
                >
                  {couponVerifyLoading ? (
                    <CircularProgress style={{ color: "#FFF" }} size={26} />
                  ) : couponDiscountData && result ? (
                    t("checkout.Applied")
                  ) : (
                    t("checkout.Apply")
                  )}
                </Button>
              </Box>

              {couponDiscountData && result && (
                <div>
                  <Divider sx={{ my: 2 }} />
                  <h3 style={{ color: "green" }}>{t("checkout.applied")}</h3>
                  <Box display="flex" justifyContent="space-between" my={1}>
                    <Typography color="text.secondary">
                      {t("checkout.oriPrice")}
                    </Typography>
                    <Typography fontWeight="bold">€{data?.price}</Typography>
                  </Box>

                  <Box display="flex" justifyContent="space-between" my={1}>
                    <Typography color="text.secondary">
                      {t("checkout.discount")}
                    </Typography>
                    <Typography fontWeight="bold">
                      {couponDiscountData.discount_type === 1
                        ? `${couponDiscountData.discount_amount}%`
                        : `€${couponDiscountData.discount_amount}`}
                    </Typography>
                  </Box>
                  {/* <Box display="flex" justifyContent="space-between" my={1}>
                    <Typography color="text.secondary">
                      Saved:
                    </Typography>
                    <Typography fontWeight="bold">
                      {result?.savedAmount.toFixed(2)}
                    </Typography>
                  </Box> */}
                  <Box display="flex" justifyContent="space-between" my={1}>
                    <Typography color="text.secondary">
                      {/* {t("checkout.company_name")} */}
                      {t("checkout.fPrice")}
                    </Typography>
                    <Typography fontWeight="bold">
                      €{result?.finalAmount.toFixed(2)}
                    </Typography>
                  </Box>
                </div>
              )}

              <Divider sx={{ my: 2 }} />

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#EDF4FF"
                borderRadius={1}
                p={1}
              >
                <Typography fontWeight="bold" color="text.secondary">
                  {t("checkout.total_price")}
                </Typography>
                <Typography fontWeight="bold" color="#164FA1" variant="h6">
                  €{result?.finalAmount.toFixed(2) ?? data?.price}
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* PayPal Button */}
              <Button
                fullWidth
                variant="contained"
                sx={{
                  bgcolor: "#ffc439",
                  color: "#00457C",
                  fontWeight: "bold",
                  "&:hover": { bgcolor: "#f3b800" },
                  p: 1,
                  display:
                    data?.subType === 1 || isFreeViaCoupon ? "none" : "flex",
                }}
                disabled={loading}
                startIcon={<PayPalIcon />}
                onClick={() => {
                  let updatedData;

                  if (couponDiscountData && result) {
                    updatedData = {
                      ...data,
                      coupon_code: result.couponCode,
                      coupon_price: +result?.finalAmount.toFixed(2),
                    };
                  } else {
                    updatedData = data;
                  }

                  handlePaypalSubmit(updatedData);
                  setCurrentLoading(1);
                }}
              >
                {loading && currentLoading == 1 ? (
                  <CircularProgress style={{ color: "#f57c00" }} size={26} />
                ) : (
                  t("checkout.paypal")
                )}
              </Button>

              {/* Debit or Credit Card Button */}
              <Button
                fullWidth
                variant="contained"
                sx={{
                  bgcolor: "#333",
                  color: "#fff",
                  fontWeight: "bold",
                  mt: 1,
                  "&:hover": { bgcolor: "#000" },
                  p: 1,
                  display:
                    couponDiscountData && result && finalAmountRef === 0
                      ? "none"
                      : "flex",
                }}
                disabled={loading}
                onClick={() => {
                  let updatedData;

                  if (couponDiscountData && result) {
                    updatedData = {
                      ...data,
                      coupon_code: result.couponCode,
                      coupon_price: +result?.finalAmount.toFixed(2),
                    };
                  } else {
                    updatedData = data;
                  }

                  handleCardSubmit(updatedData);
                  setCurrentLoading(2);
                }}
                startIcon={<CreditCardIcon />}
              >
                {loading && currentLoading == 2 ? (
                  <CircularProgress style={{ color: "#f57c00" }} size={26} />
                ) : (
                  t("checkout.credit_card")
                )}
              </Button>

              {/* { Free Subscription button } */}
              {isFreeViaCoupon && (
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    bgcolor: "#fd5D29",
                    color: "#fff",
                    fontWeight: "bold",
                    "&:hover": { bgcolor: "#fd5D29" },
                    p: 1,
                  }}
                  disabled={loading}
                  startIcon={<AddIcon />}
                  onClick={() => {
                    let updatedData;

                    if (couponDiscountData && result) {
                      updatedData = {
                        ...data,
                        coupon_code: result.couponCode,
                        coupon_price: +result?.finalAmount.toFixed(2),
                      };
                    } else {
                      updatedData = data;
                    }

                    handlePaypalSubmit(updatedData);
                    setCurrentLoading(1);
                  }}
                >
                  {loading && currentLoading == 1 ? (
                    <CircularProgress style={{ color: "#f57c00" }} size={26} />
                  ) : (
                    t("checkout.Submit")
                  )}
                </Button>
              )}
            </CardContent>
          </Card>
        </Box>
      </Modal>
    </div>
  );
}
